import { render } from "./PrintApplication.vue?vue&type=template&id=87fffef4&scoped=true"
import script from "./PrintApplication.vue?vue&type=script&lang=js"
export * from "./PrintApplication.vue?vue&type=script&lang=js"

import "./PrintApplication.vue?vue&type=style&index=0&id=87fffef4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fffef4"]])

export default __exports__